import React, { Component } from 'react';

import BarHeader from 'dibs-elements/dist/BarHeader';
import Tooltip from 'dibs-react-tooltip';
import 'dibs-react-tooltip/dist/main.css';

import { procurementCta as copy } from '../../../../../json/copy/pdp.json';
import styles from './TradeProcurementCta.scss';

class TradeProcurementInfoLink extends Component {
    constructor() {
        super();

        this.state = {
            tooltipIsOpen: false,
        };

        this.openTooltip = this.openTooltip.bind(this);
        this.closeTooltip = this.closeTooltip.bind(this);
    }
    openTooltip() {
        this.setState({
            tooltipIsOpen: true,
        });
    }
    closeTooltip() {
        this.setState({
            tooltipIsOpen: false,
        });
    }
    render() {
        const { tooltipIsOpen } = this.state;
        return (
            <div className={styles.info}>
                <span
                    className={styles.infoLink}
                    onMouseOver={this.openTooltip}
                    onMouseOut={this.closeTooltip}
                >
                    {copy.infoLink}
                    <Tooltip
                        isVisible={tooltipIsOpen}
                        tooltipDirection="bottom"
                        containerClass={styles.tooltip}
                    >
                        <div className={styles.barHeaderWrapper}>
                            <BarHeader title={copy.tooltipTitle} />
                        </div>
                        <div className={styles.tooltipContent}>{copy.tooltipDescription}</div>
                    </Tooltip>
                </span>
            </div>
        );
    }
}

export default TradeProcurementInfoLink;



// WEBPACK FOOTER //
// ./assets/js/global/components/TradeProcurement/TradeProcurementInfoLink.jsx